<template>
  <div class="centered">
    <img
      height="40"
      width="40"
      :src="iconCreateField"
    >
    <p>
      <strong>{{ $t('NoFincas') }}</strong><br>
      {{ `${$t('common.pleasePress')} + ${$t('paraCrearUnaFinca')}` }}
    </p>
  </div>
</template>

<script>
import icCreateField from '@/static/img/ic_add_farm.svg';

export default {
  name: 'NoFieldsInfo',
  computed: {
    iconCreateField() {
      return icCreateField;
    },
  },
};
</script>

<style scoped lang="scss">
.centered {
  text-align: center;
  padding: 5px;
}
</style>
